import { StyleSheet } from 'react-native'
import { fontFamily } from '../../../../../theme'
import { DS } from '@/design-system'

export const styles = StyleSheet.create({
  information: {
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center'
  },
  highlight: {
    backgroundColor: DS.palette['Global/White'],
    width: 24,
    height: 20,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center'
  }
})
